<form [formGroup]="passwordForm">
    <div class="mibi-form-group">
        <mibi-form-field>
            <mat-form-field>
                <mat-label>Passwort</mat-label>
                <input
                    matInput
                    placeholder="Geben Sie ein Passwort ein"
                    type="password"
                    name="password1"
                    formControlName="password1"
                    required
                >
                <mat-error>Zu schwaches oder zu kurzes Passwort.</mat-error>
            </mat-form-field>
        </mibi-form-field>

        <mibi-form-field>
            <mat-form-field>
                <mat-label>Passwort bestätigen</mat-label>
                <input
                    matInput
                    placeholder="Bestätigen Sie Ihr Passwort"
                    type="password"
                    name="password2"
                    formControlName="password2"
                    required
                >
                <mat-error>Passwörter müssen übereinstimmen.</mat-error>
            </mat-form-field>
        </mibi-form-field>
    </div>

    <password-strength-meter [password]="passwordForm.value.password1" minPasswordLength="8">
    </password-strength-meter>
</form>